import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.357 13.571V11H4.75l-1.16 1.16a.429.429 0 0 1-.606-.606l9.428-9.428a.428.428 0 1 1 .606.606l-1.22 1.22-1.395 3.786 1.204 1.955a.857.857 0 0 1-.73 1.307H8.214v2.571a.429.429 0 1 1-.857 0Zm-1.751-3.428h5.27L9.564 8.01l-.11-.177.898-2.437-4.746 4.747Zm3.847-7.5c.392 0 .586.476.306.75L5.737 7.312a.437.437 0 0 1-.72-.178L3.809 3.429a.6.6 0 0 1 .57-.786h5.074ZM5.622 6.226 8.42 3.5H4.733l.889 2.726Z';
const draw24px =
  'M19.358 2.22a.75.75 0 0 1 1.06 1.06l-2.201 2.202-2.133 5.962-.015.067a.312.312 0 0 0 .052.2l2.05 3.111c.564.859-.051 1.851-.93 1.972l-.178.012h-4.596v4.454l-.004.076a.741.741 0 0 1-.737.664l-.076-.004a.741.741 0 0 1-.665-.736v-4.454H6.893l-2.25 2.25a.75.75 0 0 1-1.061-1.06L19.358 2.22ZM8.403 15.306h8.29l-1.825-2.77a1.814 1.814 0 0 1-.292-1.165l.008-.09.034-.156.02-.095.033-.091 1.06-2.962-7.328 7.329ZM14.92 3.002a.5.5 0 0 1 .272.848L7.98 11.062l-.05.043a.5.5 0 0 1-.774-.229l-1.957-5.47-.006-.018c-.406-1.235.578-2.391 1.803-2.392h7.844l.08.006ZM6.895 4.508a.426.426 0 0 0-.233.147.289.289 0 0 0-.059.121.272.272 0 0 0 .012.134l1.42 3.973 4.39-4.387h-5.43l-.1.012Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const UnpinIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'unpin'),
) as IconWithRender;

UnpinIcon.displayName = 'UnpinIcon';
UnpinIcon.propTypes = Icon.propTypes;
UnpinIcon.renderIcon = (props) => <UnpinIcon {...props} />;
export default UnpinIcon;
